/**
 * This class represent datepicker toggle element with show value element.
 */
 export default class DatePickerToggle {

  /**
   * Constructor.
   *
   * @param {Element} root
   * @param {String} flowContext which point in date range choosing flow does this toggl represents (start or end)
   * @param {RangeDatePicker} datepicker
   */
    constructor(root, flowContext, datepicker)
    {
        this.root = root;
        this.value = root.find('[data-datepicker-value]');

        this.datepicker = datepicker;
        this.flowContext = flowContext;
    }

  /**
   * Will initialise start/end date of datepicker.
   *
   * @param {Function} dateSetFunction function that will be used for setting date from session (startDate or endDate)
   */
    init(dateSetFunction)
    {

      /**
       * Initialize date with value from session
       */
        if (this.root.data('initDate') != '') {
            dateSetFunction(this.root.data('initDate'));
        }
    }

  /**
   * Will initialise toggling logic.
   */
    initClick()
    {
      /**
       * On toggle click show datepicker
       */
        this.root.click((event) => {
            event.stopPropagation();
            event.preventDefault();

            if (this.datepicker.canToggle()) {
                 this.activate();

                 this.datepicker.datepicker.show();
                 this.datepicker.isReRendering = true;
            } else {
                 this.datepicker.openSearchRespoModal((this.flowContext == 'start')? 0 : 1);
            }
        });
    }

  /**
   * Will activate toggle.
   */
    activate()
    {
        this.datepicker.context.deactivateAllActions();
        this.root.addClass('active');
        this.datepicker.setFlowStep(this.flowContext);
        this.datepicker.canShow = true;
    }

  /**
   * Will deactivate toggle.
   */
    deactivate()
    {
        this.root.removeClass('active');
    }

  /**
   * This function will display given date
   *
   * @param {String} formattedDate
   */
    showDate(formattedDate)
    {
        if (formattedDate == '') {
            this.clear();
        } else {
            this.value.html(formattedDate);
        }
    }

  /**
   * This function will clear shown date and show placeholder.
   */
    clear()
    {
        this.showDate(this.value.data('datepickerValue'));
    }
 }